const initShadeVariants = (container = document.querySelector('[data-product-main]')) => {
  const shadeContainer = container?.querySelector('[data-shade-variants-container]');
  if (!shadeContainer) return;

  const filterBtns = shadeContainer.querySelectorAll('[data-shade-filter]');
  const swatches = shadeContainer.querySelectorAll('[data-shade-swatch]');
  const descriptionEl = shadeContainer.querySelector('[data-shade-description]');
  const dropdown = shadeContainer.querySelector('[data-shade-dropdown]');
  const dropdownCheckbox = dropdown?.querySelector('[data-shade-dropdown-checkbox]');
  const dropdownChevron = dropdown?.querySelector('[data-shade-dropdown-chevron]');
  const dropdownOptions = dropdown?.querySelectorAll('[data-shade-option]');
  const dropdownOptionItems = dropdown?.querySelectorAll('[data-shade-option-item]');
  const triggerImg = dropdown?.querySelector('[data-shade-trigger-img]');
  const triggerLabel = dropdown?.querySelector('[data-shade-trigger-label]');
  const triggerSwatchContainer = dropdown?.querySelector('[data-shade-trigger-swatch-container]');

  const closeDropdown = () => {
    if (dropdownCheckbox) dropdownCheckbox.checked = false;
    dropdownChevron?.classList.remove('rotate-180');
  };

  const updateUI = (variantId, optionValue, swatchUrl, shortDescription) => {
    const id = String(variantId);

    swatches.forEach(s => {
      const isActive = s.dataset.variantId === id;
      s.toggleAttribute('data-active', isActive);
      s.classList.toggle('border-black', isActive);
      s.classList.toggle('border-transparent', !isActive);
    });

    if (triggerImg && triggerImg.tagName === 'IMG' && swatchUrl) {
      triggerSwatchContainer?.classList.remove('hidden');
      triggerImg.src = swatchUrl;
    }
    if (triggerLabel) triggerLabel.textContent = optionValue;

    dropdownOptions?.forEach(opt => {
      const check = opt.querySelector('[data-shade-option-check]');
      if (check) check.classList.toggle('hidden', opt.dataset.variantId !== id);
    });

    if (descriptionEl) descriptionEl.textContent = shortDescription || '';
  };

  const selectVariant = (variantId, optionName, optionValue, swatchUrl, shortDescription) => {
    const radio = shadeContainer.querySelector(`[data-variant-input][name="${optionName}"][value="${optionValue}"]`);
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateUI(variantId, optionValue, swatchUrl, shortDescription);
    closeDropdown();
  };

  const applyFilter = (filter) => {
    filterBtns.forEach(btn => {
      btn.classList.toggle('underline', btn.dataset.shadeFilter === filter);
    });

    swatches.forEach(s => {
      s.hidden = filter !== 'all' && s.dataset.shadeGroup !== filter;
    });

    dropdownOptionItems?.forEach(item => {
      item.hidden = filter !== 'all' && item.dataset.shadeGroup !== filter;
    });

    const activeSwatch = shadeContainer.querySelector('[data-shade-swatch][data-active]');
    if (activeSwatch?.hidden) {
      const firstVisible = shadeContainer.querySelector('[data-shade-swatch]:not([hidden])');
      if (firstVisible) {
        const { variantId, optionValue, optionName, swatchUrl, shortDescription } = firstVisible.dataset;
        selectVariant(variantId, optionName, optionValue, swatchUrl, shortDescription);
      }
    }
  };

  // Chevron tracks checkbox
  dropdownCheckbox?.addEventListener('change', () => {
    dropdownChevron?.classList.toggle('rotate-180', dropdownCheckbox.checked);
  });

  // Close on outside click — use mousedown so it fires before the checkbox change
  document.addEventListener('mousedown', e => {
    if (dropdownCheckbox?.checked && dropdown && !dropdown.contains(e.target)) {
      closeDropdown();
    }
  });

  // Tab clicks
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      window.__kashGalleryEnabled = true;
      applyFilter(btn.dataset.shadeFilter);
      window.__kashGalleryEnabled = false;
    });
  });

  // Swatch clicks
  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      window.__kashGalleryEnabled = true;
      const { variantId, optionValue, optionName, swatchUrl, shortDescription } = swatch.dataset;
      selectVariant(variantId, optionName, optionValue, swatchUrl, shortDescription);
      window.__kashGalleryEnabled = false;
    });
  });

  // Dropdown option clicks — use closest to handle clicks on child elements (img, span)
  dropdown?.addEventListener('click', e => {
    const opt = e.target.closest('[data-shade-option]');
    if (!opt) return;
    window.__kashGalleryEnabled = true;
    const { variantId, optionValue, optionName, swatchUrl, shortDescription } = opt.dataset;
    selectVariant(variantId, optionName, optionValue, swatchUrl, shortDescription);
    window.__kashGalleryEnabled = false;
  });

  // Sync UI when an external source (e.g. MMM widget) changes a radio directly
  shadeContainer.querySelectorAll('[data-variant-input]').forEach(radio => {
    radio.addEventListener('change', () => {
      if (!radio.checked) return;
      const swatch = shadeContainer.querySelector(`[data-shade-swatch][data-option-value="${CSS.escape(radio.value)}"]`);
      if (swatch) {
        const { variantId, optionValue, swatchUrl, shortDescription } = swatch.dataset;
        updateUI(variantId, optionValue, swatchUrl, shortDescription);
      }
    });
  });

  // Only restore state if a variant was explicitly passed in the URL
  const urlHasVariant = new URL(window.location.href).searchParams.has('variant');
  if (urlHasVariant) {
    const activeSwatch = shadeContainer.querySelector('[data-shade-swatch][data-active]');
    if (activeSwatch) {
      const { variantId, optionValue, swatchUrl, shortDescription } = activeSwatch.dataset;
      updateUI(variantId, optionValue, swatchUrl, shortDescription);
    }
  }
};

export default initShadeVariants;
